<template>
    <div class="share-popup">
        <!-- 分享 -->
        <van-share-sheet v-model="showShare" title="分享好友(Share Friends)" :options="shartOptions" @select="onShareSelect" />
        <template v-if="posterUse == 'default'">
            <posterHtmlDefault :user="user" id="posterHtml" v-show="false" />
        </template>
        <template v-else>
            <posterHtmlCustom :user="user" :codeUrl="copyContent" id="posterHtml" v-show="false" />
        </template>
        <div class="shareImg" v-show="shareImg">
            <div class="qr-code">
                <img class="poster-img" :src="posterImg" alt />
                <div>
                    <p>长按图片保存到手机</p>
                    <p>Long press the image to save to your phone</p>
                </div>

                <img class="close" @click="shareImg = false" src="@/assets/img/icon-close.png" alt />
            </div>
        </div>
    </div>
</template>

<script>
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex';
import html2canvas from 'html2canvas';
import posterHtmlDefault from './poster/posterHtmlDefault';
import posterHtmlCustom from './poster/posterHtmlCustom';
import { getUrlCode } from '@/utils/index.js';
export default {
    props: {
        user: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    data() {
        return {
            posterUse: 'default',
            base64Img: '',
            showShare: false,
            copyContent: '',
            posterImg: '', // 最终生成的海报图片
            shareImg: false,
            shartOptions: [
                { name: '复制链接', icon: 'link' },
                { name: '分享海报', icon: 'poster' },
            ],
        };
    },
    watch: {
        user(newValue, oldValue) {
            const { acid } = getUrlCode();
            var path = this.defaultInfo.config.homeUrl || 'login';
            let url = process.env.VUE_APP_H5_API + '/?acid=' + acid + '#/' + path;
            this.copyContent = `${url}?source=${this.user.id}`;
        },
    },
    components: {
        vueQr,
        posterHtmlCustom,
        posterHtmlDefault,
    },

    computed: {
        ...mapGetters(['defaultInfo']),
    },

    methods: {
        open() {
            this.showShare = true;
        },

        // 分享
        onShareSelect(option) {
            switch (option.name) {
                case '分享海报':
                    this.createPoster();

                    this.showShare = false;
                    break;
                case '复制链接':
                    this.copyLink();
                    this.showShare = false;
                    break;
                case '二维码':
                    break;
            }
        },

        createPoster() {
            // 生成海报
            const vm = this;
            const domObj = document.getElementById('posterHtml');

            html2canvas(domObj, {
                useCORS: true,
                allowTaint: false,
                logging: false,
                letterRendering: true,
                onclone(doc) {
                    let e = doc.querySelector('#posterHtml');
                    e.style.display = 'block';
                },
            }).then(function (canvas) {
                // 在微信里,可长按保存或转发
                vm.posterImg = canvas.toDataURL('image/png');
                vm.shareImg = true;
            });
        },

        copyLink() {
            var input = document.createElement('textarea'); // 直接构建input
            input.value = this.copyContent; // 设置内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand('Copy'); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$toast.success('复制成功');
            this.showShare = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.posterHtml {
    box-sizing: border-box;
    color: #000;
    padding: 20px;
    border-radius: 2px;
    background: #fff;

    img {
        width: 100%;
    }

    .posterConent {
        padding: 10px;

        .title {
            font-weight: bold;
            font-size: 16px;
        }

        p {
            margin-bottom: 5px;
            font-size: 16px;
        }
    }

    .posterHtml-title {
        margin-bottom: 10px;

        p {
            padding: 5px;
        }
    }

    .posterHtml-img {
        border-radius: 10px;
    }

    .posterHtml-wrap {
        width: 100%;

        background: #fff;
        display: flex;

        justify-content: center;

        .poster-qrcode {
            padding: 0 10px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
                width: 100px;
                height: 100px;
            }
            p {
                color: #999;
                font-size: 14px;
            }
        }
    }
}

.shareImg {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);

    .qr-code {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .poster-img {
            width: 100%;
        }
        p {
            margin-top: 10px;
            color: #fff;
            text-align: center;
        }

        .close {
            margin-top: 8px;
            width: 50px;
            height: 50px;
        }
    }
}
</style>